export default "__VITE_ASSET__0a75d167__"